import React, { useState } from 'react'
import './groupingmodal.css'
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { createGuestList, updateGuestList } from '../../../redux/reducers/eventSlice';
import {snackbarContext} from '../../helpers/Snakbar'
const GroupingModal = ({onClose,events,mode,guestList}) => {
      const setStateSnackbarContext=React.useContext(snackbarContext)
    const dispatch=useDispatch()
    const [values, setValues] = useState({
    groupname: guestList?.groupname || "",
    eventIds: guestList?.eventIds || []
});


const handleChange = (e) => {
    setValues((prev) => ({
        ...prev,
        [e.target.name]: e.target.value
    }));
};

const handleEventSelection = (eventId, checked) => {

    setValues((prev) => {

     const updatedEventIds = checked
    ? [...prev.eventIds, eventId]
    : prev.eventIds.filter(id => id !== eventId);

return {
    ...prev,
    eventIds: updatedEventIds
};

    });

};

const handleSubmit = () => {

    if (!values.groupname.trim()) {
        // return alert("Please enter guest list name.");
        return setStateSnackbarContext(true,"Please enter guest list name","warning")
    }

    if (values.eventIds.length === 0) {
        // return alert("Please select at least one event.");
         return setStateSnackbarContext(true,"Please select at least one event","warning")
    }
    //   dispatch(createGuestList({values,setStateSnackbarContext,onClose}))

      if (mode === "create") {

        dispatch(createGuestList({
            values,
            setStateSnackbarContext,
            onClose
        }));

    } else {

        dispatch(updateGuestList({

            code: guestList.code,

            values,

            setStateSnackbarContext,

            onClose

        }));

    }

};

  return (
    <div className="grouping-modal-overlay">

    <div className="grouping-modal-container">

   <div className="guest-modal">

    <button className="modal-close"  onClick={()=>onClose(false)}>
        <CloseIcon   />
    </button>

    <h2>
    {mode === "edit"
        ? "Edit Guest List"
        : "Create Guest List"}
</h2>

 <p className="modal-helper">

    {mode === "edit"
        ? "Update the guest list name or change the events included."
        : "Give your guest list a name and choose which events should be visible to guests in this list."}

</p>

    <div className="guest-name-field">
        <label>Guest List Name</label>

        <input
            type="text"
            name='groupname'
            value={values.groupname}
            onChange={handleChange}
            placeholder="e.g. Family, Friends, Office"
        />
    </div>

    <div className="event-selection">

        <span className="event-heading">
            Select Events
        </span>

        <span className="event-helper">
            Guests in this list will only see the selected events.
        </span>

        <div className="event-checkbox-list">
  
   {events && events.length > 0 ? (
    events.map((event) => (
      <label
        className="single-event"
        key={event._id}
      >
        <input
          type="checkbox"
          checked={values.eventIds.includes(event._id)}
        //   value={event._id}
          onChange={(e) =>
                    handleEventSelection(
                        event._id,
                        e.target.checked
                    )
          }
        />

        <span>{event.eventName}</span>
      </label>
    ))
  ) : (
    <p className="no-events-text">
      No events found.
    </p>
  )}
    
        </div>
    </div>

    <button className="create-list-btn"   onClick={handleSubmit}>
        {mode === "edit"
    ? "Update Guest List"
    : "Create Guest List"}
    </button>

</div>
</div>
</div>
  )
}

export default GroupingModal